module.exports = __webpack_public_path__ + "img/score_bg.6f2462d4.png";